import React from "react";
type ExhibitProps = {
  label: string;
  title: string;
  source?: string;
  tone?: "light" | "dark";
  className?: string;
  children: React.ReactNode;
};
export function Exhibit({
  label,
  title,
  source,
  tone = "light",
  className = "",
  children
}: ExhibitProps) {
  const dark = tone === "dark";
  return <figure className={`border-t pt-5 ${dark ? "border-ivory/40" : "border-navy"} ${className}`} data-id="element-99" data-mp="61vqbweazvie">
      <p className={`eyebrow ${dark ? "text-ivory/70" : "text-oxblood"}`} data-id="element-100" data-mp="34lm7fd563mg7">{label}</p>
      <p className={`mt-3 max-w-2xl font-display text-2xl leading-snug ${dark ? "text-ivory" : "text-navy"}`} data-id="element-101" data-mp="39j46mbtdunb0">{title}</p>
      <div className="mt-8" data-id="element-102" data-mp="3ehpb4nfo3t59">{children}</div>
      {source && <figcaption className={`mt-6 border-t pt-3 text-xs leading-relaxed ${dark ? "border-ivory/15 text-ivory/55" : "border-stone text-charcoal/60"}`} data-id="element-103" data-mp="3jhk0gmjsoao7">
          {source}
        </figcaption>}
    </figure>;
}